// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

type VinStockRowProps = {
    vin: string;
    stockNumber: string;
};

export const VinStockRow = ({ vin, stockNumber }: VinStockRowProps) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                    Vin:
                </Typography>
                <Typography variant="body-md" tag="span">
                    {vin || '—'}
                </Typography>
            </Box>

            <Typography variant="body-md" tag="span">
                |
            </Typography>

            <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                    Stock#:
                </Typography>
                <Typography variant="body-md" tag="span">
                    {stockNumber || '—'}
                </Typography>
            </Box>
        </Box>
    );
};
